import { AptiError } from "@/core/errors";
import type { GetPresignedUrlForGetPayload, GetPresignedUrlForGetResponse } from "@/core/types";
import { sharedRequestsTyped } from "@/api/(requests)/sharedTyped";

export async function getPresignedUrl(
  payload: Omit<GetPresignedUrlForGetPayload, "method" | "content_type">,
): Promise<GetPresignedUrlForGetResponse> {
  try {
    const response = await sharedRequestsTyped.get_presigned_url({
      data: { content_type: "json", method: "get_object", ...payload },
    });

    // Handle null/undefined response from API
    if (!response) {
      throw new AptiError({
        code: "S3_INVALID_PRESIGNED_RESPONSE",
        message: "Backend returned empty response - this may indicate a server error",
      });
    }

    return response;
  } catch (error) {
    // Re-throw AptiError validation errors as-is
    if (error instanceof AptiError) {
      throw error;
    }

    // Wrap other errors with context
    throw new AptiError({
      cause: error,
      code: "S3_PRESIGNED_URL_FAILED",
      message: "Failed to get presigned URL for S3 download",
    });
  }
}
